/* eslint-disable no-unused-vars */
import axios from "axios";
import swal from "sweetalert";
import { loginConfirmedAction, Logout } from "../store/actions/AuthActions";

const API_URL = import.meta.env.VITE_REACT_APP_BACKEND_URL;

export async function loginSA(email, password) {
  return axios
    .post(`${API_URL}/auth/login`, {
      email,
      password,
    })
    .then((response) => response.data)
    .catch((error) => {
      // rejette l'erreur pour la propager au catch du loginAction
      return Promise.reject(error);
    });
}

export async function verify2FALogin(tempToken, code) {
  return axios
    .post(`${API_URL}/auth/verify-2fa`, {
      tempToken,
      code,
    })
    .then((response) => response.data);
}

export async function get2FAStatus() {
  const response = await axios.get(`${API_URL}/auth/2fa/status`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
    },
  });
  return response.data;
}

export async function setup2FA() {
  const response = await axios.post(
    `${API_URL}/auth/2fa/setup`,
    {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
      },
    }
  );
  return response.data;
}

export async function enable2FA(code) {
  const response = await axios.post(
    `${API_URL}/auth/2fa/enable`,
    { code },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
      },
    }
  );
  return response.data;
}

export async function disable2FA(code, currentPassword) {
  const response = await axios.post(
    `${API_URL}/auth/2fa/disable`,
    { code, currentPassword },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
      },
    }
  );
  return response.data;
}

export async function userProfile() {
  try {
    // Envoi de la requête GET avec le token dans l'en-tête Authorization
    const response = await axios.get(`${API_URL}/auth/usertk`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
      },
    });

    return response.data.user; // Retourner les données de l'utilisateur
  } catch (error) {
    console.error(
      "Erreur lors de la récupération des données utilisateur :",
      error
    );
    throw error;
  }
}

// END
export function signUp(email, password) {
  //axios call
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
    postData
  );
}

export function login(email, password) {
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
    postData
  );
}

export function formatError(errorResponse) {
  switch (errorResponse.error.message) {
    case "EMAIL_EXISTS":
      //return 'Email already exists';
      swal("Oops", "Email already exists", "error");
      break;
    case "EMAIL_NOT_FOUND":
      //return 'Email not found';
      swal("Oops", "Email not found", "error", { button: "Try Again!" });
      break;
    case "INVALID_PASSWORD":
      //return 'Invalid Password';
      swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
      break;
    case "USER_DISABLED":
      return "User Disabled";

    default:
      return "";
  }
}

export function saveTokenInLocalStorage(tokenDetails) {
  tokenDetails.expireDate = new Date(
    new Date().getTime() + tokenDetails.expiresIn * 1000
  );
  localStorage.setItem("userDetails", JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
  setTimeout(() => {
    //dispatch(Logout(history));
    dispatch(Logout(navigate));
  }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
  const tokenDetailsString = localStorage.getItem("tokenLogin");
  let tokenDetails = "";
  if (!tokenDetailsString) {
    dispatch(Logout(navigate));
    return;
  }

  tokenDetails = JSON.parse(tokenDetailsString);
  let expireDate = new Date(tokenDetails.expireDate);
  let todaysDate = new Date();

  if (todaysDate > expireDate) {
    dispatch(Logout(navigate));
    return;
  }

  dispatch(loginConfirmedAction(tokenDetails));

  const timer = expireDate.getTime() - todaysDate.getTime();
  runLogoutTimer(dispatch, timer, navigate);
}
export function isLogin() {
  const tokenDetailsString = localStorage.getItem("userDetails");

  if (tokenDetailsString) {
    return true;
  } else {
    return false;
  }
}
